import { render, staticRenderFns } from "./CatalogueStoreLocationsPopup.vue?vue&type=template&id=61240cde&scoped=true&"
import script from "./CatalogueStoreLocationsPopup.vue?vue&type=script&lang=ts&"
export * from "./CatalogueStoreLocationsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogueStoreLocationsPopup.vue?vue&type=style&index=0&id=61240cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61240cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61240cde')) {
      api.createRecord('61240cde', component.options)
    } else {
      api.reload('61240cde', component.options)
    }
    module.hot.accept("./CatalogueStoreLocationsPopup.vue?vue&type=template&id=61240cde&scoped=true&", function () {
      api.rerender('61240cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/CatalogueStoreLocationsPopup.vue"
export default component.exports